import React from 'react';
import { Home } from './pages/Home';
import { Toaster } from 'sonner';
export function App() {
  return <div dir="rtl" className="overflow-x-hidden font-sans text-[#1a1424]" data-id="element-0">
      <Toaster position="top-center" richColors data-id="element-1" />
      <Home data-id="element-2" />
    </div>;
}